import { algoliasearch } from 'algoliasearch';

const appId = process.env.REACT_APP_ALGOLIA_APP_ID;
const apiKey =
  process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY ||
  'dc3127488321a721c8d23e4c99589522';

// Initialize Algolia client safely so missing env vars don't crash the app
export const searchClient =
  appId && apiKey ? algoliasearch(appId, apiKey) : null;

// Index configurations
export const ALGOLIA_INDICES = {
  PRODUCTS: process.env.REACT_APP_ALGOLIA_PRODUCTS_INDEX || 'prod_products',
  SERVICES: process.env.REACT_APP_ALGOLIA_SERVICES_INDEX || 'mamaket_services',
  UNIFIED: process.env.REACT_APP_ALGOLIA_UNIFIED_INDEX || 'mamaket_unified_search'
};

// Search configuration
export const SEARCH_CONFIG = {
  hitsPerPage: 20,
  attributesToSnippet: ['description:50'],
  snippetEllipsisText: '…',
  highlightPreTag: '<mark>',
  highlightPostTag: '</mark>',
  typoTolerance: 'min',
  removeWordsIfNoResults: 'lastWords',
  facetingAfterDistinct: false,
  distinct: true,
  getRankingInfo: true
};

// Search parameters for autocomplete
export const AUTOCOMPLETE_CONFIG = {
  hitsPerPage: 8,
  attributesToSnippet: [],
  highlightPreTag: '<mark>',
  highlightPostTag: '</mark>',
  clickAnalytics: true,
  typoTolerance: 'min'
};

// Helper function to get index
export const getSearchIndex = (indexName) => {
  return searchClient.initIndex(indexName);
};

// Helper function for unified search across multiple indices
export const multiIndexSearch = async (query, options = {}) => {
  const { hitsPerPage = 10, page = 0 } = options;
  
  try {
    const results = await searchClient.multipleQueries([
      {
        indexName: ALGOLIA_INDICES.PRODUCTS,
        query,
        params: {
          hitsPerPage,
          page,
          ...SEARCH_CONFIG,
          facets: ['category', 'country.name', 'price'],
          numericFilters: options.priceFilters || []
        }
      },
      {
        indexName: ALGOLIA_INDICES.SERVICES,
        query,
        params: {
          hitsPerPage,
          page,
          ...SEARCH_CONFIG,
          facets: ['category', 'location'],
          numericFilters: options.priceFilters || []
        }
      }
    ]);
    
    return {
      products: results.results[0],
      services: results.results[1],
      totalHits: results.results[0].nbHits + results.results[1].nbHits
    };
  } catch (error) {
    console.error('Algolia search error:', error);
    throw error;
  }
};

// Search insights configuration
export const searchInsights = {
  init: () => {
    if (typeof window !== 'undefined' && window.aa) {
      window.aa('init', {
        appId: process.env.REACT_APP_ALGOLIA_APP_ID,
        apiKey: process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY,
        useCookie: true
      });
    }
  },
  
  trackClick: (eventName, objectIDs, positions) => {
    if (typeof window !== 'undefined' && window.aa) {
      window.aa('clickedObjectIDs', {
        eventName,
        objectIDs,
        positions
      });
    }
  },
  
  trackConversion: (eventName, objectIDs) => {
    if (typeof window !== 'undefined' && window.aa) {
      window.aa('convertedObjectIDs', {
        eventName,
        objectIDs
      });
    }
  }
};
